import React, { useState, useEffect, useRef } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-yaml';
import 'ace-builds/src-min-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/ext-searchbox';

import './index.scss';
// 初始化Ace基础配置
// import ace from 'ace-builds/src-noconflict/ace';
// ace.config.set('basePath', 'https://cdn.jsdelivr.net/npm/ace-builds@1.43.1/src-noconflict/');
// ace.config.setModuleUrl('ace/mode/yaml_worker', 'https://cdn.jsdelivr.net/npm/ace-builds@1.43.1/src-noconflict/worker-yaml.js');

const YamlEditor = (props: any) => {
  const { value = '', onChange, readOnly = false, completions = [], ...restProps } = props || {};
  const editorRef = useRef(null);
  const [content, setContent] = useState(value);
  const [errors, setErrors] = useState<any>([]);
  const [isValid, setIsValid] = useState(true);

  // 受控
  useEffect(() => {
    setContent(value);
  }, [value]);

  // 初始化编辑器配置
  const onLoad = (editor: any) => {
    editor.completers = [{
      getCompletions: (editor, session, pos, prefix, callback) => {
        callback(null, completions);
      },
    }];
  };

  // YAML 校验
  const validateYaml = async (yamlText) => {
    try {
      const yaml = await import('js-yaml');
      yaml.load(yamlText);
      setErrors([]);
      setIsValid(true);
    } catch (e: any) {
      setErrors([{
        row: e?.mark?.line || 0,
        column: e?.mark?.column || 0,
        text: e?.message,
        type: 'error'
      }]);
      setIsValid(false);
    }
  };

  // YAML 格式化
  const formatYaml = async () => {
    try {
      const yaml = await import('js-yaml');
      const parsed = yaml.load(content);
      const formatted = yaml.dump(parsed, {
        indent: 2,
        lineWidth: -1, // 不自动换行
        quotingType: '"',
        forceQuotes: false
      });
      setContent(formatted);
    } catch (e) {
      console.error('格式化失败:', e);
    }
  };

  // 内容变化处理
  const handleChange = (newValue: any) => {
    setContent(newValue);
    validateYaml(newValue);
    onChange?.(newValue, isValid);
  };

  return (<AceEditor
    ref={editorRef}
    mode="yaml"
    theme="monokai"
    value={content}
    onChange={handleChange}
    readOnly={readOnly}
    name="yaml-editor"
    width="100%"
    height="100%"
    fontSize={14}
    focus={true}
    annotations={errors}
    onLoad={onLoad}
    setOptions={{
      useWorker: false, // 未初始化Ace基础配置,禁用worker，否则会报错
      wrapEnabled: true,
      highlightActiveLine: true,
      enableBasicAutocompletion: true, // 启用基本自动完成功能
      enableLiveAutocompletion: true, // 启用实时自动完成功能 （比如：智能代码提示）
      enableSnippets: true, // 启用代码段
      showLineNumbers: true,
      tabSize: 2,
      showPrintMargin: false,
    }}
    editorProps={{ $blockScrolling: true }}
    {...(restProps || {})}
  />);
};

export default YamlEditor;